import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

type CardActivationSlideProps = { activationError: string | null };

export const CardActivationSlideHeader = ({ activationError }: CardActivationSlideProps) => (
  <div
    data-testid="card-activation-slide"
    className="text-center space-y-4 animate-fade-in"
  >
    <H2 className=" text-primary text-pretty">
      Saisissez votre code d'activation
    </H2>
    <P className="text-base animate-slide-up text-pretty" color={activationError ? "error" : "base"}>
      {activationError
        ? activationError
        : "Retournez votre carte et saisissez l'identifiant d'activation présent au dos."}
    </P>
  </div>
);
